// packages/api-client/src/services/apiKeyService.ts
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type {
  ApiKeyListResponseItem,
  ApiKeyCreatePayload,
  ApiKeyCreatedResponse,
  ApiSuccessResponse,
  ServiceResponse,
  UUID,
} from '@dopomogai/types';

export const apiKeyService = {
  getAllKeys: (): ServiceResponse<ApiKeyListResponseItem[]> => {
    return getApiClient().get<ApiKeyListResponseItem[]>('/api-keys')
      .then(response => response.data)
      .catch(err => handleApiError(err, 'listing API keys'));
  },

  createKey: (payload: ApiKeyCreatePayload): ServiceResponse<ApiKeyCreatedResponse> => {
    return getApiClient().post<ApiKeyCreatedResponse>('/api-keys', payload)
      .then(response => response.data)
      .catch(err => handleApiError(err, 'creating API key'));
  },

  revokeKey: (keyId: UUID): ServiceResponse<ApiSuccessResponse> => {
    return getApiClient().delete(`/api-keys/${keyId}`)
      // Return an object that matches the ApiSuccessResponse interface
      .then(() => ({ status: 'success' } as const))
      .catch(err => handleApiError(err, `revoking API key ${keyId}`));
  },
};